<template>
  <div class="mt-2 mx-3">
    <div>
      <v-sheet class="rounded-0 shadow-none">
        <v-row justify="center">
          <!-- <v-col
            cols="12"
            class="mt-1 no-space"
            align-self="center"
            md="6"
            sm="6"
          >
            <v-chip-group
              v-model="selection"
              active-class="light-green darken-3 white--text"
              class="mx-auto chip-selector"
              center-active
              @change="getFilterADP(selection)"
              mandatory
            >
              <v-chip
                v-for="selection in position"
                :key="selection"
                :value="selection"
              >
                {{ selection }}
              </v-chip>
            </v-chip-group>
          </v-col> -->
        </v-row>
      </v-sheet>
      <div v-if="loader">
        <v-skeleton-loader
          :loading="loader"
          class="mb-3 mt-4"
          type="list-item-avatar-two-line,table,paragraph"
          elevation="2"
        >
        </v-skeleton-loader>
      </div>

      <div v-else>
        <!--//? Studs table-->
        <div class="mt-5">
          <v-sheet elevation="3" class="mt-0 mt-md-4">
            <div>
              <v-data-table
                height="910"
                :headers="computedHeaders"
                :items="build_exposure.data"
                item-key="Name"
                class="elevation-1 exposure-table"
                :footerProps="footerProps"
                mobile-breakpoint="0"
              >
                <!-- header -->
                <template
                  v-for="h in computedHeaders"
                  v-slot:[`header.${h.value}`]="{ computedHeaders }"
                >
                  <v-tooltip bottom :key="h.text">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ h.text }}</span>
                    </template>
                    <span>{{ h.hint }}</span>
                  </v-tooltip>
                </template>
                <!-- header -->

                <template v-slot:header.PhotoUrl="{ header }">
                  <v-btn
                    icon
                    color="blue"
                    @click.prevent="$emit('hideExposureBuild')"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>

                <!-- profile image -->
                <template v-slot:item.PhotoUrl="{ item }">
                  <v-avatar width="37" height="48">
                    <img :src="item.PhotoUrl" />
                  </v-avatar>
                </template>
                <!-- profile image ends -->

                <!-- player name -->
                <template v-slot:item.Name="{ item }">
                  <router-link
                    :to="{
                      name: 'PlayerDetail',
                      params: {
                        playerId: item.PlayerID,
                        SportId: item.SportId,
                      },
                    }"
                    style="text-decoration: none"
                    class="blue--text"
                  >
                    {{ item.Name }}
                  </router-link>
                </template>
                <!-- player name ends -->

                <template v-slot:item.exposure="{ item }">
                  <p>{{ item.exposure >> 0 }}</p>
                </template>
              </v-data-table>
            </div>
          </v-sheet>
        </div>
        <!--//? studs table ends -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BuildExposure",
  props: ["allSlate", "defaultSport", "defaultOptimizer"],

  data: () => ({
    footerProps: { "items-per-page-options": [25, 35, 70, -1] },
    userId: localStorage.getItem("user"),
    //   position: ['Overall', 'C', '1B', '2B', '3B', 'SS', 'OF', 'P'],
    //   selection: 'Overall',

    DKheaders: [
      {
        text: "",
        value: "PhotoUrl",
        hint: "Profile",
        sortable: false,
        width: 80,
        align: "center",
      },
      { text: "Player", value: "Name", hint: "Name", align: "center" },
      { text: "Team", value: "Team", hint: "Team", align: "center" },
      {
        text: "Position",
        hint: "position",
        value: "DraftKingsPosition",
        sortable: false,
        align: "center",
      },
      { text: "Exposure(%)", value: "exposure", hint: "exposure(%)" },
    ],

    FDheaders: [
      {
        text: "",
        value: "PhotoUrl",
        hint: "Profile",
        sortable: false,
        width: 80,
        align: "center",
      },
      { text: "Player", value: "Name", hint: "Name", align: "center" },
      { text: "Team", value: "Team", hint: "Team", align: "center" },
      {
        text: "Position",
        hint: "position",
        value: "FanDuelPosition",
        sortable: false,
        align: "center",
      },
      { text: "Exposure(%)", value: "exposure", hint: "exposure(%)" },
    ],
  }),

  computed: {
    ...mapState("userModule", ["build_exposure", "loader"]),

    computedHeaders() {
      if (this.defaultOptimizer) {
        if (this.defaultOptimizer == "DraftKings") {
          return this.DKheaders;
        } else {
          return this.FDheaders;
        }
      }
    },
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.chip-selector >>> .v-chip.v-size--default {
  border-radius: 8px;
}

.v-chip-group >>> .v-slide-group__content {
  padding: 4px 0;
  display: flex;
  justify-content: center;
}
</style>
